import { render, staticRenderFns } from "./DesignService2018.vue?vue&type=template&id=b7c4dc74&"
import script from "./DesignService2018.vue?vue&type=script&lang=js&"
export * from "./DesignService2018.vue?vue&type=script&lang=js&"
import style0 from "./DesignService2018.vue?vue&type=style&index=0&id=b7c4dc74&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports